import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {disabledDeleteBtn} from '../actions/disabled-delete-button';

export interface IDeleteProps{
    isShowInlineMsg?: boolean;
    errCode?: string;
    errorSubcode?: string;
    typeOfMethods?: string;
}
export function disabledDeleteButton(data: IDeleteProps):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch) => {
        dispatch(disabledDeleteBtn(data));
    }
}
